export const SLIPPAGE_OPTIONS = [
  {
    label: "0.5%",
    value: 0.5,
    isDefault: false,
  },
  {
    label: "1%",
    value: 1,
    isDefault: true,
  },
  {
    label: "5%",
    value: 5,
    isDefault: false,
  },
  {
    label: "10%",
    value: 10,
    isDefault: false,
  },
];

export const PRIORITY_FEE_OPTIONS = [
  {
    label: "Economy",
    value: 0.0015,
    isDefault: false,
  },
  {
    label: "Standard",
    value: 0.015,
    isDefault: true,
  },
  {
    label: "Fast",
    value: 0.05,
    isDefault: false,
  },
];

export const VALIDATOR_TIP_OPTIONS = [
  {
    label: "Low",
    value: 0.0005,
    isDefault: false,
  },
  {
    label: "Medium",
    value: 0.001,
    isDefault: true,
  },
  {
    label: "High",
    value: 0.01,
    isDefault: false,
  },
];
